/**
 * Shop The Look
 * Handles Hotspot clicks
 */

class ShopTheLook extends HTMLElement {
  connectedCallback() {
    this.hotspots = this.querySelectorAll('[data-hotspot-product]');
    if (this.hotspots.length === 0) return;

    this.productCards = this.querySelectorAll('[data-product-id]');

    this.hotspots.forEach(hotspot => {
      hotspot.addEventListener('click', () => this.handleHotspotInteraction(hotspot));
      hotspot.addEventListener('mouseenter', () => this.handleHotspotInteraction(hotspot, true));
    });
  }

  handleHotspotInteraction(hotspot, isMouseEnter = false) {
    // remove the active class from all hotspots and product cards
    this.hotspots.forEach(hotspot => hotspot.classList.remove('shop-the-look__hotspot--active'));
    this.productCards.forEach(productCard => productCard.classList.remove('product-card-inline--active'));

    // add the active class to the clicked hotspot
    hotspot.classList.add('shop-the-look__hotspot--active');

    // get the product id from the clicked hotspot + add the active class to the corresponding product card
    const hotspotProductId = hotspot.dataset.hotspotProduct;
    const highlightedProduct = this.querySelector(`[data-product-id="${hotspotProductId}"]`);
    highlightedProduct?.classList.add('product-card-inline--active');

    if (isMouseEnter) return;

    highlightedProduct?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', ShopTheLook);
}
